import P from 'prop-types';
import { spacing } from '@nerdwallet/base-styles/variables';

export const backgroundSizes = [
  { label: 'Cover', value: 'cover' },
  { label: 'Contain', value: 'contain' },
  { label: 'Auto', value: 'auto' },
];

export const backgroundPositionXValues = [
  { label: 'Left', value: 'left' },
  { label: 'Center', value: 'center' },
  { label: 'Right', value: 'right' },
];

export const backgroundPositionYValues = [
  { label: 'Top', value: 'top' },
  { label: 'Center', value: 'center' },
  { label: 'Bottom', value: 'bottom' },
];

const moveArrayItemPosition = (array, oldIndex, newIndex) => {
  let resultIndex = newIndex;
  if (newIndex >= array.length) {
    resultIndex = array.length - 1;
  }
  array.splice(resultIndex, 0, array.splice(oldIndex, 1)[0]);
  return array;
};

// Parsing base-styles spacing values to array and removing "--wide" entries
const mapCurrencySpacingSizes = Array.from(
  new Map(Object.entries(spacing)),
  ([key, value]) => ({ label: key, value })
).filter((item) => !item.label.includes('--wide'));

// Let's use "moveArrayItemPosition" to prevent the "3-half" size from being in the last position
const currencySpacingSizes = moveArrayItemPosition(
  mapCurrencySpacingSizes,
  6,
  4
);

export const capitalize = (text) =>
  text.toLowerCase().charAt(0).toUpperCase() + text.slice(1);

// Once Top, Left, Right and bottom will be the same for both padding and margin
// let's avoid repeatable code and use this builder to handle this.
export const buildSpacingInputs = (
  inputComponent,
  fielName,
  fieldList = [],
  extraLabel = '',
  isSelectInput
) => {
  const help = {
    help: 'Defaults to "0"',
  };
  if (isSelectInput) {
    return fieldList.map((input) =>
      inputComponent(
        `${fielName}.${input}`,
        `${capitalize(input)}`,
        [...currencySpacingSizes, { label: 'Auto', value: 'auto' }],
        help
      )
    );
  }
  return fieldList.map((input) =>
    inputComponent(
      `${fielName}.${input}`,
      `${capitalize(input)} ${extraLabel}`,
      help
    )
  );
};

export const universalContainerPropTypes = {
  children: P.node,
  backgroundImageDesktop: P.string,
  backgroundImageTablet: P.string,
  backgroundImageMobile: P.string,
  backgroundSize: P.oneOf(['contain', 'cover', 'auto']),
  size: P.string,
  backgroundColor: P.string,
  hexColor: P.string,
  jumpLinkId: P.string,
  padding: P.shape({
    type: P.string,
    currency: {
      top: P.string,
      right: P.string,
      bottom: P.string,
      left: P.string,
    },
    custom: {
      top: P.string,
      right: P.string,
      bottom: P.string,
      left: P.string,
    },
  }),
  margin: P.shape({
    type: P.string,
    currency: {
      top: P.string,
      right: P.string,
      bottom: P.string,
      left: P.string,
    },
    custom: {
      top: P.string,
      right: P.string,
      bottom: P.string,
      left: P.string,
    },
  }),
  border: P.shape({
    type: P.string,
    borderWidth: P.string,
    borderColor: P.string,
    shadowColor: P.string,
    borderRounded: P.shape({
      type: P.string,
      value: P.oneOfType([P.string, P.number]),
      currencyValue: P.string,
    }),
  }),
  width: P.shape({
    type: P.string,
    screenSizes: P.shape({
      lg: P.bool,
      md: P.bool,
      sm: P.bool,
    }),
    currency: {
      value: P.string,
    },
    custom: {
      value: P.string,
    },
  }),
  alignment: P.shape({
    vertical: P.string,
    horizontal: P.string,
    direction: P.string,
    type: P.string,
  }),
  hide: P.shape({
    lg: P.bool,
    md: P.bool,
    sm: P.bool,
  }),
  style: P.object,
};

export const universalContainerDefaultProps = {
  children: null,
  backgroundImageDesktop: '',
  backgroundImageTablet: '',
  backgroundImageMobile: '',
  backgroundSize: 'cover',
  size: 'lg',
  jumpLinkId: '',
  padding: {
    type: 'currency',
    currency: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
    },
    custom: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
    },
  },
  margin: {
    type: 'currency',
    currency: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
    },
    custom: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
    },
  },
  border: {
    type: 'none',
    borderWidth: 1,
    borderColor: '#cdcdcd',
    shadowColor: '',
    borderRounded: {
      type: 'currency',
      value: '0',
      currencyValue: 'border-radius-1',
    },
  },
  width: {
    type: 'currency',
    screenSizes: {
      lg: false,
      md: false,
      sm: false,
    },
    currency: {
      value: '',
    },
    custom: {
      value: '',
    },
  },
  alignment: {
    type: 'none',
    vertical: 'flex-start',
    horizontal: 'flex-start',
    direction: 'column',
  },
  hide: {
    lg: false,
    md: false,
    sm: false,
  },
};
